import { html, LitElement, css, unsafeCSS } from 'lit';

import { TooltipComponent } from '../components/tooltip';

import style from './affix.scss';
import { DATA_AFFIXES } from '../data/sources';
import { isTouchDevice } from '../shared/utils';

export class AffixPart extends LitElement {

    static get properties() {
        return {
            id: String,
            inline: Boolean
        }
     }

    constructor() {
        super();
        this.id = null;
        this.inline = false;
        this.tooltip = new TooltipComponent();
    }

    static styles = css`
        ${unsafeCSS(style)}        
    `;

    render() {   
        const affixes = DATA_AFFIXES.filter(c=>c.name.toLowerCase()===this.id.toLowerCase());
        if(affixes.length === 0)
            return html`[affix not found - ${this.id}]`;
        const affix = affixes[0];
        const tooltipval = {
            type: 'Affix',                        
            name: affix.name,
            desc: affix.desc,
            artwork: affix.artwork
        };
        return html`
            ${this.tooltip}
            ${!this.inline? html`
                <div 
                    @mouseleave=${this.tooltip.debouncer((ev) => this.tooltip.mouseOut(ev))} 
                    @mouseenter=${this.tooltip.debouncer((ev) => this.tooltip.mouseOver(ev,tooltipval))} 
                    class="artwork"
                    style="background-image:url(./images/affixes/${(affix.artwork || '').replace(/ /g, '%20')}.webp);">
                </div>  
            `:''}                 
            <div
                @mouseleave=${this.tooltip.debouncer((ev) => this.tooltip.mouseOut(ev))} 
                @mouseenter=${this.tooltip.debouncer((ev) => this.tooltip.mouseOver(ev,tooltipval))}
                class="name ${!this.inline?'img-name':'inline-name'}">
                    ${!isTouchDevice()? html`${affix.name}`:affix.name}                    
                </div>                                
            </div>                       
        `;
    }
}

customElements.define('affix-part', AffixPart);